export default "__VITE_ASSET__DmgpNUoP__"